import DepositMenuActions from './DepositMenuActions/DepositMenuActions'
import FilterDepositByStatus from './FilterDepositByStatus/FilterDepositByStatus'
import FilterDepositInput from './FilterDepositInput/FilterDepositInput'

export const options = {
  FilterDepositInput,
  FilterDepositByStatus,
  DepositMenuActions
}
